module.exports = __webpack_public_path__ + "static/media/servImg1.25e84a42.png";